import { Box, FormControlLabel, Checkbox, Typography, useTheme } from "@mui/material";

function SimpleCheckbox(props) {
  const {
    checked = false,
    color = "primary",
    disabled = false,
    helperText,
    inputProps,
    label = "",
    name = "",
    onChange,
    size = "medium",
  } = props;

  const theme = useTheme();
  const { palette = {} } = theme;
  const { primary = {}, success = {} } = palette;

  // Brand colors
  const navyColor = primary?.main || "#002843";
  const greenColor = success?.main || "#A0C46D";

  // Touch-friendly sizing (minimum 44x44px touch target)
  const sizeMap = {
    small: {
      checkbox: "1.25rem",
      padding: "8px",
      label: "0.875rem",
    },
    medium: {
      checkbox: "1.5rem",
      padding: "10px",
      label: "0.9375rem",
    },
    large: {
      checkbox: "1.75rem",
      padding: "12px",
      label: "1rem",
    },
  };

  const currentSize = sizeMap[size] || sizeMap.medium;

  return (
    <Box>
      <FormControlLabel
        disabled={disabled}
        sx={{
          margin: 0,
          padding: "4px 0",
          // Touch target: ensure the entire area is tappable
          minHeight: "44px",
          alignItems: "center",
          "&:hover .MuiCheckbox-root": {
            backgroundColor: disabled ? "transparent" : "rgba(160, 196, 109, 0.08)",
          },
          "& .MuiFormControlLabel-label": {
            color: disabled ? "#94a3b8" : "#1e293b",
            fontWeight: 500,
            fontSize: currentSize.label,
            fontFamily: '"Lato", sans-serif',
            marginLeft: "4px",
            userSelect: "none", // Prevent text selection on double-tap
          },
        }}
        control={
          <Checkbox
            checked={checked}
            disabled={disabled}
            inputProps={{
              "aria-label": label,
              "aria-checked": checked,
              ...inputProps,
            }}
            onChange={(e) => {
              onChange(e);
            }}
            name={name}
            sx={{
              padding: currentSize.padding,
              borderRadius: "8px",
              transition: "all 0.2s ease-in-out",
              color: "#cbd5e1",
              "&.Mui-checked": {
                color: greenColor,
              },
              "&.Mui-disabled": {
                color: "#e2e8f0",
              },
              "&:hover": {
                backgroundColor: disabled ? "transparent" : "rgba(160, 196, 109, 0.08)",
              },
              // Accessibility: Clear focus state
              "&.Mui-focusVisible": {
                outline: `2px solid ${greenColor}`,
                outlineOffset: "2px",
              },
              "& .MuiSvgIcon-root": {
                fontSize: currentSize.checkbox,
              },
            }}
          />
        }
        label={label}
      />
      
      {/* Helper text for additional context */}
      {helperText && (
        <Typography
          sx={{
            color: "#64748b",
            fontSize: "0.75rem",
            marginLeft: "36px",
            marginTop: "-4px",
          }}
        >
          {helperText}
        </Typography>
      )}
    </Box>
  );
}

export default SimpleCheckbox;
